import { useState } from 'react';
import { Modal } from '~/components/overlays/Modal';
import { useTranslation } from 'react-i18next';

import { Plus } from 'lucide-react';
import { AddInventoryModal } from '~/pages/buyer-inventory/sections/AddInventoryModal.tsx';
import { useLocation } from 'react-router';
import { InventoryTable } from './sections/InventoryTable';

export default function BuyerInventories() {
  const { t } = useTranslation('inventory');
  const [showAddInventory, setShowAddInventory] = useState(false);
  const location = useLocation();

  return (
    <main className="flex-1 overflow-y-auto">
      <div className="space-y-6">
        <div className="bg-neut-0 rounded-lg border border-neut-200 shadow-sm p-6">
          <div className="flex items-start justify-between">
            <div>
              <h1 className="text-2xl font-semibold text-neut-900 mb-1">
                {t('inventory.overview')}
              </h1>
              <p className="text-sm text-neut-500">
                {t('inventory.description')}
              </p>
            </div>
          </div>
        </div>
        <div className="flex flex-col">
          <div className="bg-neut-0 rounded-lg border border-neut-200 shadow-sm">
            <div className="px-6 py-4 border-b border-neut-200 flex items-center justify-between">
              <div>
                <h2 className="text-lg text-neut-900 font-semibold">
                  {t('inventory.current')}
                </h2>
                <p className="text-xs text-neut-500 mt-1">
                  {t('inventory.current_description')}
                </p>
              </div>
              <div className="flex items-center gap-3">
                <button
                  className="px-4 py-2 bg-prim-500 text-neut-0 rounded-lg hover:bg-tab-count-active-text transition-colors text-xs md:text-sm font-medium flex items-center gap-2"
                  onClick={() => setShowAddInventory(true)}
                  aria-label={t('inventory.add')}
                >
                  <Plus size={16} strokeWidth={2} aria-hidden="true" />
                  {t('inventory.add')}
                </button>
              </div>
            </div>

            <InventoryTable key={location.pathname} t={t} />
          </div>
          <Modal
            isOpen={showAddInventory}
            onClose={() => setShowAddInventory(false)}
          >
            <AddInventoryModal setShowAddInventory={setShowAddInventory} />
          </Modal>
        </div>
      </div>
    </main>
  );
}
